import React from 'react';
import { connect } from 'react-redux';
import withAuth from '../../hocs/withAuth';

import LoadingCard from '../../cards/LoadingCard';

import styles from './upgradeToUtrCollege.scss';

import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';
import ListItem from '../UpgradeCheckList/ListItem';
import UpgradeCheckList from '../UpgradeCheckList';
import TrackedClick from '../../Analytics/TrackedClick';
import { getClickAttrs } from '../../Analytics/gtag';
import withStatsig from '../../hocs/withStatsig';

class LearnMoreUtrCollegeContent extends React.Component {
    constructor(props) {
        super(props);

        let clubToUpgrade = null;

        if (props.clubOptionsToUpgrade?.length === 1) {
            clubToUpgrade = {
                id: props.clubOptionsToUpgrade[0].value,
                name: props.clubOptionsToUpgrade[0].label,
                tierTypeName: 'free college',
            };
        }

        this.state = {
            clubToUpgrade,
        };

        this.handleClubUpgradeChange = this.handleClubUpgradeChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchUpgradePopup('collegepro');
    }

    handleClubUpgradeChange(e) {
        const { selectedIndex } = e.nativeEvent.target;

        if (selectedIndex > 0) {
            this.setState({
                clubToUpgrade: {
                    id: parseInt(e.target.value),
                    name: e.nativeEvent.target[selectedIndex].text,
                    tierTypeName: 'free college',
                },
            });
        } else {
            this.setState({
                clubToUpgrade: null,
            });
        }
    }

    render() {
        const { handleUpgradeClick, clubOptionsToUpgrade, upgradePopup, checkGate, featureGates, 'data-testid': dataTestId } = this.props;
        const { data } = upgradePopup;
        const isV2026Pricing = checkGate(featureGates.COLLEGE_COACH_V2026_PRICING);
        const yearlyButtonText = isV2026Pricing
            ? 'Upgrade for only $199 (USD)'
            : (data.yearlybuttontext || 'Upgrade to UTR Sports College for only $149');

        return (
            <div data-testid={dataTestId}>
                {!upgradePopup.isLoading ? (
                    <>
                        <UpgradeCheckList
                            title={data.title}
                            intro={data.subtitle}
                        >
                            {data.bulletpoints?.map((bulletpoint, index) => (
                                <ListItem key={`${bulletpoint}-${index}`}>{bulletpoint}</ListItem>
                            ))}
                            {(clubOptionsToUpgrade && clubOptionsToUpgrade.length > 1) && (
                                <div className={`d-flex flex-row ${styles.listItem}`}>
                                    <select
                                        className="form-control"
                                        onChange={(e) => this.handleClubUpgradeChange(e)}
                                        data-testid={dataTestId ? `${dataTestId}.club-select` : undefined}
                                    >
                                        <option value="">Select a school to upgrade to UTR Sports College</option>
                                        {clubOptionsToUpgrade.map((option) => {
                                            return (
                                                <option value={option.value} key={option.value}>{option.label}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </UpgradeCheckList>
                        <div>
                            <div className={`d-flex flex-row ${styles.buttonArea}`}>
                                <div className="w-100">
                                    <TrackedClick
                                        eventName="Upgrade to Pro College Click"
                                        label={yearlyButtonText}
                                        traits={
                                            {
                                                pageLocation: 'Try UTR Sports College Popup',
                                                uxType: 'button',
                                                content: yearlyButtonText,
                                                subscriptionType: 'Pro College',
                                            }
}
                                    >
                                        <button
                                            type="button"
                                            className={`w-100 btn btn-primary btn-block btn-xl text-uppercase font-weight-normal`}
                                            onClick={() => {
                                                handleUpgradeClick(this.state.clubToUpgrade);
                                            }}
                                            disabled={!this.state.clubToUpgrade}
                                            {...getClickAttrs({
                                                category: 'College Upgrade',
                                                context: 'Upgrade to Pro College Click',
                                                location: 'Try UTR Sports College Popup',
                                            })}
                                            data-testid={dataTestId ? `${dataTestId}.upgrade-btn` : undefined}
                                        >
                                            {yearlyButtonText}
                                        </button>
                                    </TrackedClick>
                                </div>
                            </div>
                        </div>
                    </>
                ) : <LoadingCard /> }
            </div>

        );
    }
}
const mapStateToProps = ({ auth, upgradePopup }) => {
    return { auth, upgradePopup };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUpgradePopup: (prismicUid) => dispatch(fetchUpgradePopup(prismicUid)),
    };
};

export default withAuth(withStatsig(connect(mapStateToProps, mapDispatchToProps)(LearnMoreUtrCollegeContent)));
